import i18n from "i18n";

let allLocales;
import("date-fns/locale").then((locales) => {
    allLocales = locales;
});

// date-fns uses different locale keys than i18n language codes
const I18N_TO_DATE_FNS: Record<string, string> = {
    en: "enUS",
    "en-IN": "enGB",
    "en-UK": "enGB",
};

export const getLocale = () => {
    const lang = i18n.language || navigator.language;
    const dateFnsKey = I18N_TO_DATE_FNS[lang] ?? lang.replace("-", "");
    const rootLocale = dateFnsKey.substring(0, 2);

    return allLocales?.[dateFnsKey] || allLocales?.[rootLocale];
};
